import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import participantSearchReducer from './participants';
import siteSearchReducer from './sites';
import siteReducer from './site';
import participantReducer from './participant';

const store = configureStore({
  reducer: {
    participants: participantSearchReducer,
    participant: participantReducer,
    sites: siteSearchReducer,
    site: siteReducer,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
  ],
});
export type RootState = ReturnType<typeof store.getState>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => any = useDispatch; // Export a hook that can be reused

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
